// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1KYdD","imageUploader":"EGiftCard_imageUploader__lEEQN"};